<template>
  <div style="display: flex;justify-content: space-between;">
    <div style="width:50%;">
      <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:580px">
        <el-form
          :inline="true"
          :model="contract_data"
          class="demo-form-inline"
          label-width="110px"
        >
          <el-form-item style="width:96%" class="contract-fa-title">
            <div style="font-size:20px">电子合约</div>
          </el-form-item>
          <br />
          <el-form-item label="采购方：">
            <el-input
              :disabled="btn_modify"
              v-model="contract_data.PartA"
              placeholder="请输入采购方店铺id"
            ></el-input>
          </el-form-item>
          <el-form-item label="供货方：">
            <!-- style="margin-left:-20px" -->
            <el-input
              :disabled="btn_modify"
              v-model="contract_data.PartB"
              placeholder="请输入供货方店铺id"
            ></el-input>
          </el-form-item>
          <br />

          <div style="display:flex;">
            <el-form-item style="margin-bottom:0px" label="开始日期：">
              <div id="date-div">
                <el-date-picker
                @change="dateChange($event,'start_time')"
                  v-model="contract_data.start_time"
                  type="date"
                  placeholder="选择合同开始日期"
                ></el-date-picker>
              </div>
            </el-form-item>

            <el-form-item style="margin-bottom:0px" label="截止日期：">
              <div id="date-div">
                <el-date-picker
                  @change="dateChange($event,'expire_in')"
                  v-model="contract_data.expire_in"
                  type="date"
                  placeholder="选择合同截止日期"
                ></el-date-picker>
              </div>
              <div>
                <el-switch
                  v-model="islong"
                  active-text="长期有效"
                  inactive-text="约定日期"
                >
                </el-switch>
              </div>
            </el-form-item>
          </div>
          <el-form-item v-if="btn_modify" label="合约状态：">
            <el-select style="width:160px" v-model="status" placeholder="请选择">
              <el-option
                v-for="item in status_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="110px">
          <el-form-item style="margin-bottom:0px" label="查看：">
            <el-checkbox-group @change="checkedUpdate" v-model="checked_scope">
              <el-checkbox
                v-for="item in query_goods"
                :label="item"
                :key="item"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item style="margin-bottom:0px" label="修改：">
            <el-checkbox-group @change="checkedUpdate" v-model="checked_scope">
              <el-checkbox
                v-for="item in modify_goods"
                :label="item"
                :key="item"
                >{{ item }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item style="margin-bottom:0px" label="新增：">
            <el-checkbox-group @change="checkedUpdate" v-model="checked_scope">
              <el-checkbox label="新增商品">
                新增商品
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <!-- <el-button @click="subContract">生成合同</el-button> -->
    </div>
    <div style="width:50%;padding:0px 10px">
      <contractgoods
        :btn_modify="btn_modify"
        @subContract="subContract"
        @changeContract="changeContract"
        ref="contractgoodsRef"
      ></contractgoods>
    </div>
  </div>
</template>

<script lang="js">

import contractgoods from "./contractgoods.vue"
import { contractGenreate,modifycontract } from "@/api/baseinfo.js";
import {timeFun} from "@/js/public.js";
export default {
  components: {contractgoods},
  props: {
    btn_modify:Boolean
  },
  inject:["reload"],
  data() {
    return {
      query_goods: [
        "查看进价",
        "查看售价",
        "查看规格",
        "查看保质期",
        "查看销量",
        "查看库存"
      ],
      modify_goods: ["修改进价", "修改售价", "修改规格", "修改保质期"],
      generate: "新增商品",
      checked_scope:this.btn_modify?[]:["修改进价",
        "修改售价",
        "修改规格",
        "修改保质期",
        "新增商品",
        "查看进价",
        "查看售价",
        "查看规格",
        "查看保质期",
        "查看销量",
        "查看库存"],
        /*  */
      scope: {
        query_goods: {
          sale_price: true,
          in_price: true,
          item_size: true,
          life_day: true,
          sales: true,
          stock: true
        },
        modify_goods: {
          sale_price: true,
          in_price: true,
          item_size: true,
          life_day: true
        },
        generate: true
      },
      // contract_no:"",
      islong: true,
      //表单的信息
      contract_data: {
        PartA: "6010575687",
        PartB: "8478358784",
        content: "测试",
        start_time: this.formatDate(),
        expire_in: "2099-12-30"
      },
      status:"0",
      status_options:[
        {
          label:"正常",
          value:"0"
        }
      ]
    };
  },
  created() {
  },
  methods: {
    dateChange(e,index){
      this.contract_data[index]= timeFun('slash',e);
      console.log(this.contract_data[index]);
    },
    async subContract(info,callback){
      var that = this;
      console.log(this.contract_data);
      const data = {
        partA: this.contract_data.PartA,
        partB: this.contract_data.PartB,
        content: this.contract_data.content,
        start_time: this.contract_data.start_time,
        expire_in: this.contract_data.expire_in,
        access_token: window.localStorage.getItem("access_token"),
        sponsor: window.localStorage.getItem("mch_id"),
        scope: that.scope,
        create_id: window.localStorage.getItem("user_id"),
        oper_id: window.localStorage.getItem("user_id"),
      };
      // console.log(JSON.stringify(data));
      const res = await contractGenreate(data);
      console.log("提交合同返回：", res);
      if(res.data.return_code=="SUCCESS"&&res.data.result_code=="SUCCESS"){
        that.successMessage("签约成功");
        callback(res.data.resp_data.contract_no);
      }
      if(info.e ==0){
       return;
      }
      // "CNBB078CE552461FB2D1147149F468E0"
      callback("CNBB078CE552461FB2D1147149F468E0");
    },
    async changeContract(e,callback){
      /* this.contract_data.start_time = timeFun('eng',this.contract_data.start_time);
      this.contract_data.expire_in = timeFun('eng',this.contract_data.expire_in);  */
      const data = {
        start_time: this.contract_data.start_time,
        expire_in: this.contract_data.expire_in,
        goods:e,
        request_no: this.contract_data.request_no,
        status: this.contract_data.status,
        sponsor:localStorage.getItem("mch_id"),
        content: "amet labore Excepteur consectetur",
        other1:""
   }
      const res = await modifycontract(data);
      console.log("修改合同返回值：",res);
      if(res.data.return_code=="SUCCESS"&&res.data.result_code=="SUCCESS"){
        this.successMessage("合同修改成功");
        this.reload();
      }
    },
    async subGoods(data){

    },
    checkedUpdate(e) {
      this.scope = {
        query_goods: {
          sale_price: false,
          in_price: false,
          item_size: false,
          life_day: false,
          sales: false,
          stock: false
        },
        modify_goods: {
          sale_price: false,
          in_price: false,
          item_size: false,
          life_day: false
        },
        generate: false
      };
      e.forEach((item, index, arr) => {
        switch (item) {
          case "修改进价":
            this.scope.modify_goods.in_price = true;
            break;
          case "修改售价":
            this.scope.modify_goods.sale_price = true;
            break;
          case "修改规格":
            this.scope.modify_goods.item_size = true;
            break;
          case "修改保质期":
            this.scope.modify_goods.lify_day = true;
            break;
          case "新增商品":
            this.scope.generate = true;
            break;
          case "查看进价":
            this.scope.query_goods.in_price = true;
            break;
          case "查看售价":
            this.scope.query_goods.sale_price = true;
            break;
          case "查看规格":
            this.scope.query_goods.item_size = true;
            break;
          case "查看保质期":
            this.scope.query_goods.life_day = true;
            break;
          case "查看销量":
            this.scope.query_goods.sales = true;
          case "查看库存":
            this.scope.query_goods.stock = true;
            break;
        }
      });
    },
    setUpdateInfo(e){
      console.log("createCT================：",e)
      this.contract_data = e;
      // this.$emit("contractNo",);
      this.$nextTick(()=>{
        this.$refs.contractgoodsRef.setcontractNo(e.contract_no);
      })

      const scope = JSON.parse(e.scope);
      this.checked_scope = [];
      for(let key in scope){
        switch(key){
          case "generate":
            if(scope.generate==true){
              this.checked_scope.push("新增商品")
            }
            break;
          case "modify_goods":
            for(let index in scope.modify_goods){
              if( index=="in_price"&&scope.modify_goods[index]==true){
                this.checked_scope.push("修改进价")
              }
              if( index=="sale_price"&&scope.modify_goods[index]==true){
                this.checked_scope.push("修改售价")
              }if( index=="item_size"&&scope.modify_goods[index]==true){
                this.checked_scope.push("修改规格")
              }if( index=="life_day"&&scope.modify_goods[index]==true){
                this.checked_scope.push("修改保质期")
              }
            }
            break;
          case "query_goods":
            for(let index in scope.query_goods){
              if(index == "in_price"&& scope.query_goods[index]==true){
                this.checked_scope.push("查看进价")
              }
              if(index == "item_size"&& scope.query_goods[index]==true){
                this.checked_scope.push("查看规格")
              }
              if(index == "life_day"&& scope.query_goods[index]==true){
                this.checked_scope.push("查看保质期")
              }
              if(index == "sale_price"&& scope.query_goods[index]==true){
                this.checked_scope.push("查看售价")
              }
              if(index == "sales"&& scope.query_goods[index]==true){
                this.checked_scope.push("查看销量")
              }
              if(index == "stock"&& scope.query_goods[index]==true){
                this.checked_scope.push("查看库存")
              }
            }
            break;


        }
      }
    }
  }
};
</script>
<style scoped>
.contract-fa-title {
  text-align: center;
  /* font-size: 30px; */
  width: 100%;
  height: 25px;
  margin-bottom: 20px;
}
.el-input {
  width: 160px !important;
}
#date-div >>> .el-input {
  width: 160px !important;
}
.el-form-item-fee >>> input {
  width: 40px;
  border: 0;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  border-bottom: 1px solid #f56c6c;
  color: #f56c6c;
  padding-left: 3px;
}
</style>
